import { ALLOWED_PARENTS } from 'components/generated/allowed-parents.js'
import { isInternalGuardEnabled, warnIfOrphaned } from 'components/shared/internal-guard/internal-guard.js'

export function startInternalGuard(root: Document = document): () => void {
  const internalTags = Object.keys(ALLOWED_PARENTS)
  if (internalTags.length === 0) return () => undefined

  const selector = internalTags.join(',')
  const warnedTags = new Set<string>()

  const checkElement = (element: Element) => {
    const tag = element.localName
    if (warnedTags.has(tag)) return
    if (warnIfOrphaned(element, tag, ALLOWED_PARENTS[tag])) warnedTags.add(tag)
  }

  const checkTree = (element: Element) => {
    if (element.localName in ALLOWED_PARENTS) checkElement(element)
    element.querySelectorAll(selector).forEach(checkElement)
  }

  checkTree(root.documentElement)

  const observer = new MutationObserver((records) => {
    if (!isInternalGuardEnabled()) return
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) checkTree(node)
      }
    }
  })
  observer.observe(root.documentElement, { childList: true, subtree: true })

  return () => observer.disconnect()
}

const startWhenEnabled = () => {
  if (isInternalGuardEnabled()) startInternalGuard()
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWhenEnabled, { once: true })
  } else {
    queueMicrotask(startWhenEnabled)
  }
}
